import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function DequipoImagenesTerapeuticas({ id, onSuccess }) {
  const postRemove = async (e) => {
    e.preventDefault();

    if (!window.confirm("¿Está seguro de eliminar este registro?")) return;

    try {
      await axios.delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaEquipoImagenesTerapeuticas/" +
          id,
      );

      alert("Eliminado con éxito");
      onSuccess && onSuccess(); // 🔄 recarga lista
    } catch (error) {
      console.error(error);
      alert("Error al eliminar el registro");
    }
  };

  return (
    <button className="btn btn-danger" onClick={postRemove}>
      <IoIcons.IoIosCloseCircleOutline size={20} />
    </button>
  );
}

export default DequipoImagenesTerapeuticas;
